import styled from "styled-components";

export const MainSection = styled.section`
  .navbar {
    background: rgba(2, 19, 53, 0.08);
    backdrop-filter: blur(240px);
    border-bottom: 1px solid #fff;
  }

  .new-navbar {
    background-color: #ffffff !important;
    backdrop-filter: blur(240px);
    border-bottom: 1px solid #032b88;
  }

  .navbar-light .navbar-nav .nav-link {
    font-family: "Catamaran";
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 23px;
    text-transform: capitalize;
    color: #ffffff;
    margin-left: 2rem;

    @media (max-width: 990px) {
      display: block;
      margin-left: auto;
      margin-right: auto;
    }
  }

  .navbar-light .navbar-toggler {
    background: #ffffff;
  }

  .dropdown-toggle::after {
    display: none;
  }

  .dropdown-menu {
    width: 11rem !important;
    font-size: 13px !important;
  }

  .dropdown-item {
    color: #032b88 !important;
  }

  .features-div {
    position: relative;

    @media (max-width: 991.98px) {
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
`;

export const LaunchBtn = styled.button`
  --border: 0.5px;
  --slant: 0.7em;
  --color: #fff;
  font-family: "Catamaran";
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  padding: 0.2em 1.2em;
  border: none;
  cursor: pointer;
  color: #ffffff;
  /* background: linear-gradient(90.41deg, #008bda 0.34%, #a100d5 99.15%); */
  background: linear-gradient(to bottom left, var(--color) 50%, #0000 50.1%) top
      right,
    linear-gradient(to top right, var(--color) 50%, #0000 50.1%) bottom left;
  background-size: calc(var(--slant) + 1.3 * var(--border))
    calc(var(--slant) + 1.3 * var(--border));
  background-repeat: no-repeat;
  box-shadow: 0 0 0 200px inset var(--s, #0000),
    0 0 0 var(--border) inset var(--color);
  clip-path: polygon(
    0 0,
    calc(100% - var(--slant)) 0,
    100% var(--slant),
    100% 100%,
    var(--slant) 100%,
    0 calc(100% - var(--slant))
  );
  transition: color var(--t, 0.3s), background-size 0.3s;

  &:focus-visible {
    outline-offset: calc(-1 * var(--border));
    outline: var(--border) solid #000c;
    clip-path: none;
    background-size: 0 0;
  }

  @media (max-width: 990px) {
    display: block;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 2rem;
    margin-top: 1rem;
  }
`;

export const DrawerDiv = styled.div`
  @media (min-width: 990px) {
    display: none !important;
  }
`;

export const Title = styled.h5`
  font-family: "Outfit";
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 25px;

  color: #fecf4d;
`;

export const Text = styled.span`
  font-family: "Outfit";
  font-style: normal;
  font-weight: 300;
  font-size: 18px;
  line-height: 23px;
  color: #ffffff;
`;

export const LaunchBtns = styled.button`
  --border: 0.5px;
  --slant: 0.7em;
  --color: #008bda;
  font-family: "Catamaran";
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  padding: 0.2em 1.2em;
  border: none;
  cursor: pointer;
  color: #008bda;
  /* background: linear-gradient(90.41deg, #008bda 0.34%, #a100d5 99.15%); */
  background: linear-gradient(to bottom left, var(--color) 50%, #0000 50.1%) top
      right,
    linear-gradient(to top right, var(--color) 50%, #0000 50.1%) bottom left;
  background-size: calc(var(--slant) + 1.3 * var(--border))
    calc(var(--slant) + 1.3 * var(--border));
  background-repeat: no-repeat;
  box-shadow: 0 0 0 200px inset var(--s, #0000),
    0 0 0 var(--border) inset var(--color);
  clip-path: polygon(
    0 0,
    calc(100% - var(--slant)) 0,
    100% var(--slant),
    100% 100%,
    var(--slant) 100%,
    0 calc(100% - var(--slant))
  );
  transition: color var(--t, 0.3s), background-size 0.3s;

  &:focus-visible {
    outline-offset: calc(-1 * var(--border));
    outline: var(--border) solid #000c;
    clip-path: none;
    background-size: 0 0;
  }

  @media (max-width: 990px) {
    display: block;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 2rem;
    margin-top: 1rem;
  }
`;

export const CustomDropdown = styled.div`
  position: absolute;
  top: 50px;
  width: 11rem;
  z-index: 1000;
  min-width: 10rem;
  padding: 0.5rem 0.5rem;
  margin: 0;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid rgba(0, 0, 0, 0.15);
  border-radius: 0.25rem;
`;

export const DropdownItem = styled.p`
  font-size: 0.9rem;
  color: #032b88;
  text-align: left;
  list-style: none;
  cursor: pointer;
  margin: 0;
  margin-top: 10px;

  &:first-child {
    margin-top: 0;
  }
`;
